import {Breadcrumbs as MantineBreadcrumbs} from '@mantine/core';

/**
 * Breadcrumb trail — design-layer pass-through over Mantine `Breadcrumbs`.
 * @registry Pass-through Mantine Breadcrumbs; import this instead of @mantine/core outside src/design.
 */
export const Breadcrumbs = MantineBreadcrumbs;
